import { useQuery } from '@tanstack/react-query';
import { getCustomNotificationById } from 'api/auth.api';

export const useCustomNotificationById = (id) => {
  return useQuery({
    queryKey: ['customNotificationById', id],
    queryFn: () => getCustomNotificationById(id),
    enabled: !!id,
  });
};
